/* 🤖 this file was generated by svg-to-ts */
export const DfIconTag16: {
  name: 'tag-16';
  data: string;
} = {
  name: 'tag-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.486 1c.42 0 .778.147 1.073.441.294.295.441.652.441 1.073v3.531c0 .4-.105.857-.315 1.372-.21.515-.463.92-.757 1.214L8 14.559c-.294.294-.652.441-1.072.441s-.778-.147-1.072-.441L1.44 10.144C1.147 9.85 1 9.492 1 9.072s.147-.778.441-1.072L7.37 2.072c.295-.294.694-.546 1.199-.757.504-.21.967-.315 1.387-.315zM11.5 6c.417 0 .77-.146 1.063-.438S13 4.918 13 4.5s-.146-.77-.438-1.063S11.918 3 11.5 3s-.77.146-1.063.438S10 4.082 10 4.5s.146.77.438 1.063S11.082 6 11.5 6z" fill-rule="evenodd"/></svg>`
};
